import Highcharts from "highcharts";

Highcharts.setOptions({
    lang: {
        thousandsSep: ','
    },
    chart: {
        style: {
            fontFamily: "'IBM Plex Sans', 'Helvetica', 'Arial', sans-serif"
        }
    }
});

export const defaultChartOptions = (chartTitle) => {
    return {
        title: {
            text: chartTitle,
        },
        subtitle: {
            text: "Source: Incomes Data Research",
        },
        accessibility: {
            enabled: false,
        },
        credits: {
            enabled: false,
        },
        exporting: {
            chartOptions: {
                plotOptions: {
                    series: {
                        dataLabels: {
                            enabled: false
                        }
                    }
                }
            },
            fallbackToExportServer: false
        },
    };
};
